import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortByDate',
    standalone: false
})
export class SortByDatePipe implements PipeTransform {
  transform(array: any[], dateField: string): any[] {
    if (!array || array.length === 0) {
      return array;
    }

    return array.sort((a, b) => {
      const dateA = new Date(a[dateField]).getTime();
      const dateB = new Date(b[dateField]).getTime();
      return dateB - dateA; 
    });
  }

}
